import { Component, OnInit } from '@angular/core';
import {LoggingService} from '../logging.service';
import {SkillModel} from './skill.model';
import { HttpClient } from '@angular/common/http';
import {DataService} from '../shared/data.service';


@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.css'],
  providers: [ DataService]
})
export class SkillsComponent implements OnInit {
  
  filteredCategory = '';

  badgeClassTypes: string [] = [
    'badge badge-pill badge-warning',
    'badge badge-pill badge-light',
    'badge badge-pill badge-warning',
    'badge badge-pill badge-light',
    'badge badge-pill badge-warning',
    'badge badge-pill badge-light',
    'badge badge-pill badge-warning',
    'badge badge-pill badge-light',
    'badge badge-pill badge-warning',
    'badge badge-pill badge-light',
    'badge badge-pill badge-warning',
    'badge badge-pill badge-light'
    // 'badge badge-pill badge-danger',
    // 'badge badge-pill badge-light',
    // 'badge badge-pill badge-success',
    // 'badge badge-pill badge-info',
    // 'badge badge-pill badge-primary',
    // 'badge badge-pill badge-dark',
    // 'badge badge-pill badge-secondary',

  ];


  skills: SkillModel[] = [];

  constructor(private loggingService: LoggingService,private http: HttpClient) {}

  ngOnInit(): void {
    this.loadSkills();
  }
  loadSkills(): void {
    this.http.get<SkillModel[]>('assets/data/skills.json').subscribe(
      (data) => {
        this.skills = data;
        console.log('Skills loaded:', this.skills);
        if (Array.isArray(data)) {
          this.skills = data as SkillModel[];  // Assign if it’s an array
        } else if (data && typeof data === 'object' && 'skills' in data) {
          this.skills = (data as { skills: SkillModel[] }).skills;  // Assign if it’s an object with skills property
        } else {
          console.error('Unexpected data format:', data);
        }
      },
      (error) => {
        console.error('Error loading skills:', error);
      }
    );
  }

}
